import {Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation} from '@angular/core';
import { HubPlace } from 'models/hub/hub.place';
import {Observable} from "rxjs/Observable";
import {VisitorApiService} from "../../../../services/visitor.api.service";

@Component({
    selector: 'ig-nearby-places',
    templateUrl: './nearby.places.component.html',
    styleUrls: ['./nearby.places.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NearbyPlacesComponent implements OnChanges {
    @Input() public position: 'bottom' | 'right';
    @Input() public source: 'google' | 'facebook';
    @Input() public currentPlace: HubPlace;

    public allPlaces = [];
    public isLoadingAllPlaces = false;
    public paginationIndex = 0;
    public paginationPageLimit = 5;
    public nearByPlaces = [];
    public showingCount = '';
    public noMoreNext = false;
    public noMoreBack = true;

    @Output() onGotoPlace: EventEmitter<any> = new EventEmitter();

    constructor(private visitorApiService: VisitorApiService,) {
    }

    ngOnChanges() {
        this.loadNearbyPlaces();
    }

    public gotoPlace(item: HubPlace) {
        this.onGotoPlace.emit(item);
    }

    public async loadNearbyPlaces() {
        this.isLoadingAllPlaces = true;

        this.visitorApiService.getNearByPlaces(this.currentPlace, this.source).subscribe(data => {
            this.pagination(data);
        });
    }

    public pagingBack() {
        if (this.noMoreBack) {
            return;
        }

        this.paginationIndex--;
        let start = this.paginationPageLimit * this.paginationIndex;
        let end = start + this.paginationPageLimit;
        if (start <= 0) {
            start = 0;
            this.noMoreBack = true;
        }
        this.nearByPlaces = this.allPlaces.slice(start, end);
        this.showingCount = `${start + 1} - ${end}`;
        this.noMoreNext = false;
    }

    public pagingNext() {
        if (this.noMoreNext) {
            return;
        }

        this.paginationIndex++;
        let start = this.paginationPageLimit * this.paginationIndex;
        let end = start + this.paginationPageLimit;
        if (end >= this.allPlaces.length) {
            end = this.allPlaces.length;
            this.noMoreNext = true;
        }
        this.nearByPlaces = this.allPlaces.slice(start, end);
        this.showingCount = `${start + 1} - ${end}`;
        this.noMoreBack = false;
    }

    private pagination(allPlacesWithCurrent) {
        this.allPlaces = allPlacesWithCurrent.filter(x => x._id !== this.currentPlace._id);
        this.sortPlacesByDistance();
        this.paginationIndex = 0;

        let placesInThisPage = [];
        if (this.allPlaces.length > this.paginationPageLimit) {
            let max = this.paginationPageLimit * (this.paginationIndex + 1);
            placesInThisPage = this.allPlaces.slice(0, max);
            this.showingCount = `${this.paginationPageLimit * this.paginationIndex + 1} - ${max}`;
            this.noMoreNext = false;
            this.noMoreBack = true;
        } else {
            placesInThisPage = allPlacesWithCurrent;
            this.noMoreNext = true;
            this.noMoreBack = true;
        }

        this.visitorApiService.convertGoogleImages(this.currentPlace.hubName, placesInThisPage).subscribe(converted => {
            console.log(converted.map(x => x.cover ? x.cover.source : ''));
            this.nearByPlaces = converted;
            this.isLoadingAllPlaces = false;
        });
    }

    private getPlaces(): Observable<HubPlace[]> {
        return this.visitorApiService.getPlaces(this.currentPlace.hubName, {
            page: 1,
            limit: 500,
            category: 'All',
            source: this.source
        });
    }

    private sortPlacesByDistance() {
        this.allPlaces.forEach(x => {
            let distance = this.getDistanceFromLatLng(this.currentPlace.address.lat, this.currentPlace.address.lng, x.address.lat, x.address.lng);
            x['distance'] = distance;
        });
        this.allPlaces.sortBy(x => x.distance);
    }

    public getDistanceFromLatLng = function (lat1, lon1, lat2, lon2) {
        if (!lat1 || !lon1 || !lat2 || !lon2) {
            return 0;
        }

        let R = 6371; // Radius of the earth in km
        let dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
        let dLon = this.deg2rad(lon2 - lon1);
        let a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = R * c; // Distance in km
        return d * 1000;
    };

    public deg2rad(deg) {
        return deg * (Math.PI / 180);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/place.details.modal/nearby.places.component/nearby.places.component.ts